var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiPopularmajors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107282",
    "data-name": "Group 107282",
    transform: "translate(-428 -558)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40439",
    "data-name": "Rectangle 40439",
    width: 32,
    height: 32,
    transform: "translate(428 558)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106165",
    "data-name": "Path 106165",
    d: "M42,41.333H27.333a2,2,0,0,1,0-4H42a2,2,0,1,1,0,4ZM23.333,37v4.667A2.336,2.336,0,0,1,21,44H16.333A2.336,2.336,0,0,1,14,41.667V37a2.336,2.336,0,0,1,2.333-2.333H21A2.336,2.336,0,0,1,23.333,37ZM42,30H27.333a2,2,0,0,1,0-4H42a2,2,0,1,1,0,4ZM23.333,25.667v4.667A2.336,2.336,0,0,1,21,32.667H16.333A2.336,2.336,0,0,1,14,30.333V25.667a2.336,2.336,0,0,1,2.333-2.333H21A2.336,2.336,0,0,1,23.333,25.667ZM42,18.679H27.333a2,2,0,0,1,0-4H42a2,2,0,1,1,0,4ZM23.333,14.333V19A2.336,2.336,0,0,1,21,21.333H16.333A2.336,2.336,0,0,1,14,19V14.333A2.336,2.336,0,0,1,16.333,12H21A2.336,2.336,0,0,1,23.333,14.333Z",
    transform: "translate(415.058 546)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiPopularmajors);
export default __webpack_public_path__ + "static/media/visionai_popularmajors.99e280e76f89fa47f0857883de3cc0dd.svg";
export { ForwardRef as ReactComponent };